;(function($, undefined){
    var rnn;

    function initEventHandlers(){
        $(document).on('click', 'button.closeModal', function(){
            var modal = $(this).closest('.mobileModal'),
                form = modal.closest('.noticeSearchForm'),
                closeEvent = $.Event('closeModal');

            closeEvent.target = modal[0];
            $(this).trigger(closeEvent);
        }).on('closeModal', '.mobileModal', function(event){
            event.stopPropagation();
            var modal = $(this).closest('.mobileModal');

            modal.removeClass('active');
        });
    }

    function showModal(modal){
        modal.addClass('active');
        window.scrollTo(0,0);
    }

    // Initialise Notices
    function initModals() {
        initEventHandlers();
    }

    rnn = window.rnn;

    rnn.modules.register('modal', {
        init: initModals,
        show: showModal
    });

})(jQuery);
